module.exports = {"StatusCode":200,"Payload":"[{\"location\":\"https://drz-websites.s3.us-west-2.amazonaws.com/some-file.mp3\",\"oldPath\":\"_droplet-assets/some-old-path\",\"newPath\":\"_droplet-assets/some-new-path\",\"file\":\"some-file-name.txt\",\"oldThumbPath\":\"_droplet-assets/_thumbnails/some-old-path\",\"newThumbPath\":\"_droplet-assets/_thumbnails/some-new-path\",\"thumbFile\":false}]"}


//////////////////
// WEBPACK FOOTER
// ./src/payloads/aws/lambda/mocks/copyRecycledDropletAsset.json
// module id = lsQY
// module chunks = 0